import { intersect, number, partial, string, struct } from 'io-ts/Decoder';

import { Id as FileType } from './file-type/Id';
import { Id as FileId } from './Id';
import { ParentId } from './ParentId';

export const RefItem = intersect(
	struct({
		id: FileId,
		parentId: ParentId,
		versionId: string,
		filename: string,
		numberOfPages: number,
		fileType: FileType,
	})
)(
	partial({
		label: string,
	})
);
